import React from "react";

import Header from "../header";
import Footer from "../components/footer";
import ScrollTo from "../components/scroll-to";
import LoadingIndicator from "../components/loader/loading-indicator";

import { links } from "./lib/constants";
import { Alert } from "components/alert/alert";
import { getStorageValue } from "shared/storage";

const MainLayout = ({ children }) => {
    const enableDuplicateStage = getStorageValue("duplicateMatch");

    return (
        <>
            <Alert />
            <Header
                links={links}
                enableDuplicateStage={enableDuplicateStage}
            />

            <LoadingIndicator />

            {children}
            <Footer />
            <ScrollTo />
        </>
    );
};

export default MainLayout;
